<div class="mx-auto max-w-5xl px-4 py-6 sm:px-6">
  <div class="mb-6 flex flex-wrap items-center justify-between gap-3">
    <div>
      <a routerLink="/admin/dashboard" class="text-[12px] text-action-blue hover:underline">← Admin</a>
      <h1 class="mt-1 text-xl font-bold text-midnight-indigo">Facturas</h1>
      <p class="text-[13px] text-steel-gray mt-0.5">
        Al pagar: comisión de la plataforma al propietario. El inquilino recibe un comprobante de pago (no factura de alquiler).
      </p>
    </div>
    <div class="flex items-center gap-2">
      <button
        type="button"
        (click)="repairMissingInvoices()"
        [disabled]="repairingMissing()"
        title="Genera las facturas de comisión ausentes en reservas ya pagadas"
        class="rounded-xl bg-action-blue px-3 py-2 text-[13px] font-semibold text-white hover:brightness-110 disabled:opacity-50"
      >
        {{ repairingMissing() ? 'Reparando facturas…' : 'Reparar facturas pendientes' }}
      </button>
      <button
        type="button"
        (click)="backfillOwnerUids()"
        [disabled]="backfilling()"
        title="Asigna el propietario a facturas antiguas para que las vean en su panel"
        class="rounded-xl border border-pale-gray bg-white px-3 py-2 text-[13px] font-medium text-midnight-indigo hover:bg-slate-50 disabled:opacity-50"
      >
        {{ backfilling() ? 'Reparando…' : 'Reparar propietarios' }}
      </button>
      <button
        type="button"
        (click)="reload()"
        [disabled]="loading()"
        class="rounded-xl border border-pale-gray bg-white px-3 py-2 text-[13px] font-medium text-midnight-indigo hover:bg-slate-50 disabled:opacity-50"
      >
        Actualizar
      </button>
    </div>
  </div>
  @if (backfillMsg()) {
    <p class="mb-4 text-[12px] text-slate-blue">{{ backfillMsg() }}</p>
  }
  @if (repairMissingMsg()) {
    <p class="mb-4 rounded-xl border border-pale-gray bg-cloud-mist px-4 py-3 text-[12px] text-slate-blue">
      {{ repairMissingMsg() }}
    </p>
  }

  <section class="mb-8 rounded-2xl border border-pale-gray bg-white p-4 sm:p-5">
    <h2 class="text-[14px] font-semibold text-midnight-indigo mb-3">Generar desde reserva</h2>
    <div class="flex flex-col gap-3 sm:flex-row sm:items-end">
      <label class="flex-1 block">
        <span class="text-[12px] text-steel-gray">ID reserva (Firestore)</span>
        <input
          type="text"
          [(ngModel)]="bookingIdInput"
          class="mt-1 w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]"
          placeholder="abc123…"
        />
      </label>
      <button
        type="button"
        (click)="generate()"
        [disabled]="generating()"
        class="rounded-xl bg-action-blue px-4 py-2 text-[13px] font-semibold text-white hover:bg-action-blue/90 disabled:opacity-50"
      >
        {{ generating() ? 'Generando…' : 'Generar' }}
      </button>
    </div>
    @if (generateError()) {
      <p class="mt-3 text-[13px] text-red-600">{{ generateError() }}</p>
    }
    @if (generateSuccess()) {
      <p class="mt-3 text-[13px] text-emerald-700">{{ generateSuccess() }}</p>
    }
  </section>

  @if (loadError()) {
    <p class="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[13px] text-red-700">
      {{ loadError() }}
    </p>
  }

  @if (loading()) {
    <p class="text-[13px] text-steel-gray">Cargando facturas…</p>
  } @else if (rows().length === 0) {
    <p class="text-[13px] text-steel-gray">No hay facturas todavía.</p>
  } @else {
    <div class="overflow-x-auto rounded-2xl border border-pale-gray bg-white">
      <table class="min-w-full text-left text-[13px]">
        <thead class="border-b border-pale-gray bg-slate-50 text-[11px] uppercase tracking-wide text-steel-gray">
          <tr>
            <th class="px-4 py-3 font-medium">Número</th>
            <th class="px-4 py-3 font-medium">Fecha</th>
            <th class="px-4 py-3 font-medium">Tipo</th>
            <th class="px-4 py-3 font-medium">Destinatario</th>
            <th class="px-4 py-3 font-medium text-right">Total</th>
            <th class="px-4 py-3 font-medium">Reserva</th>
            <th class="px-4 py-3 font-medium"></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.id) {
            <tr class="border-b border-pale-gray/60 last:border-0">
              <td class="px-4 py-3 font-mono text-[12px]">{{ row.invoiceNumber }}</td>
              <td class="px-4 py-3 whitespace-nowrap">{{ row.issueDate }}</td>
              <td class="px-4 py-3">{{ typeLabels[row.type] || row.type }}</td>
              <td class="px-4 py-3 max-w-[180px] truncate" [title]="row.recipientLegalName">
                {{ row.recipientLegalName }}
              </td>
              <td class="px-4 py-3 text-right tabular-nums">
                {{ formatEuros(row.totalCents) | currency:'EUR':'symbol':'1.2-2':'es' }}
              </td>
              <td class="px-4 py-3 font-mono text-[11px] text-steel-gray max-w-[120px] truncate" [title]="row.bookingId">
                {{ row.bookingId }}
              </td>
              <td class="px-4 py-3">
                <button
                  type="button"
                  (click)="print(row)"
                  [disabled]="printingId() === row.id"
                  class="inline-flex items-center gap-1 rounded-lg border border-pale-gray px-2 py-1 text-[12px] hover:bg-slate-50 disabled:opacity-50"
                >
                  <lucide-icon name="printer" [size]="14" />
                  Imprimir
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
